import { BotsMatchType, MatchmakingMatchTypes } from '@colonist/game-base-types';
import { RoomType } from '@colonist/lobby-types';
import { activeMatchmakingMatchTypes } from '../../../shared/matchmaking/MatchmakingEnums.ts';
import { uiManager } from './EntryHomepage.ts';
import { ClientUserState } from '../../shared/scripts/ClientUserState.ts';
import { SocketLobbySend } from '../../shared/scripts/socket/SocketLobbySend.ts';
import { startBotGame } from '../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts';
import { Scene } from './ui_html/UISceneTypes.ts';
import { UIUrlController, UIUrlParameterNames } from '../../shared/scripts/ui_html/UIUrlController.ts';
import { UIEntryUrlParameterController } from '../../shared/scripts/UIEntryUrlParameterController.ts';
import { UIUtilsEjsVariables } from '../../shared/scripts/UIUtilsEjsVariables.ts';
import { clientIntl } from '../../shared/scripts/ClientI18n.ts';
import { StorageWrapper } from '../../shared/scripts/StorageWrapper.ts';
import { showRewardsProgramDialog } from './ui_popup/showRewardsProgramDialog.ts';
import { SDKRequestHandler } from './discord/content_frame/sdk_requests/SDKRequestHandler.ts';
import { ShareActivityLinkAnalytics } from '../../../shared/entity_datas/EntityDatas.ts';
import { UIWAdController } from './ui_ad/UIWAdController.ts';
import { ClientShuffleQueueController } from '../../shared/scripts/shuffle/ClientShuffleQueueController.ts';
import { ReferralProgramUtils } from '../../shared/scripts/referral/ReferralProgramUtils.ts';
export class EntryHomepageUrlParameterController extends UIEntryUrlParameterController {
    static async loadParameterEvents() {
        const urlParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        for (const parameterName of urlParams.keys()){
            const parameterValue = urlParams.get(parameterName);
            if (parameterValue == null) continue;
            switch(parameterName){
                case UIUrlParameterNames.Campaign:
                    this.loadCampaignMode(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.EnterMatchmaking:
                    void this.loadMatchmakingQueue(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.EnterBotGame:
                    this.loadEnterBotGame(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.VideoAdTesting:
                    return; // intentionally returning to prevent ad test from being cleared from window
                case UIUrlParameterNames.Lobby:
                    this.loadLobbyScene(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.Spectate:
                    this.loadSpectateScene(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.MainPage:
                    this.loadMainPageScene(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.SelectMode:
                    this.loadModeSelection(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.CreateRoom:
                    void this.loadCreateRoom(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.SuppressPopupsOnLoad:
                    this.handleSuppressPopups(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.DiscordLeaderboard:
                    this.loadDiscordScene(parameterValue, Scene.DiscordLeaderboard);
                    break;
                case UIUrlParameterNames.DiscordStore:
                    this.loadDiscordScene(parameterValue, Scene.DiscordStore);
                    break;
                case UIUrlParameterNames.DiscordAbout:
                    this.loadDiscordScene(parameterValue, Scene.DiscordAbout);
                    break;
                case UIUrlParameterNames.DiscordCareers:
                    this.loadDiscordScene(parameterValue, Scene.DiscordCareers);
                    break;
                case UIUrlParameterNames.DiscordChampionship25:
                    this.loadDiscordScene(parameterValue, Scene.DiscordChampionship25);
                    break;
                case UIUrlParameterNames.DiscordChampionship26:
                    this.loadDiscordScene(parameterValue, Scene.DiscordChampionship26);
                    break;
                case UIUrlParameterNames.DiscordCommunity:
                    this.loadDiscordScene(parameterValue, Scene.DiscordCommunity);
                    break;
                case UIUrlParameterNames.DiscordFAQ:
                    this.loadDiscordScene(parameterValue, Scene.DiscordFAQ);
                    break;
                case UIUrlParameterNames.DiscordPrivacyPolicy:
                    this.loadDiscordScene(parameterValue, Scene.DiscordPrivacyPolicy);
                    break;
                case UIUrlParameterNames.DiscordPatchNotes:
                    this.loadDiscordScene(parameterValue, Scene.DiscordPatchNotes);
                    break;
                case UIUrlParameterNames.DiscordProfile:
                    this.loadDiscordScene(parameterValue, Scene.DiscordProfile);
                    break;
                case UIUrlParameterNames.DiscordGifting:
                    this.loadDiscordGiftScene(parameterValue);
                    break;
                case UIUrlParameterNames.DiscordValues:
                    this.loadDiscordScene(parameterValue, Scene.DiscordValues);
                    break;
                case UIUrlParameterNames.DiscordValuesExamples:
                    this.loadDiscordScene(parameterValue, Scene.DiscordValuesExamples);
                    break;
                case UIUrlParameterNames.DiscordTerms:
                    this.loadDiscordScene(parameterValue, Scene.DiscordTerms);
                    break;
                case UIUrlParameterNames.DiscordPressKit:
                    this.loadDiscordScene(parameterValue, Scene.DiscordPressKit);
                    break;
                case UIUrlParameterNames.DiscordRefundPolicy:
                    this.loadDiscordScene(parameterValue, Scene.DiscordRefundPolicy);
                    break;
                case UIUrlParameterNames.DiscordMore:
                    this.loadDiscordScene(parameterValue, Scene.DiscordMore);
                    break;
                case UIUrlParameterNames.DiscordShareActivity:
                    this.loadShareActivityPopup();
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.ReferralInvitation:
                    void ReferralProgramUtils.processReferralInvitation(parameterValue);
                    this.removeParameter();
                    break;
                case UIUrlParameterNames.ReconnectGame:
                    SocketLobbySend.reconnectGame(parameterValue);
                    this.removeParameter();
                    break;
                default:
                    break;
            }
        }
        const roomOrGameId = UIUrlController.getRoomIdFromUrl();
        if (roomOrGameId != undefined) {
            var _uiManager_adController_adblockState_isAdblockActive;
            await UIWAdController.initiatePopupActionFromUserState((_uiManager_adController_adblockState_isAdblockActive = uiManager === null || uiManager === void 0 ? void 0 : uiManager.adController.adblockState.isAdblockActive) !== null && _uiManager_adController_adblockState_isAdblockActive !== void 0 ? _uiManager_adController_adblockState_isAdblockActive : false);
            await SocketLobbySend.accessGameFromLink(roomOrGameId);
        }
    }
    static removeParameter() {
        window.history.replaceState({}, document.title, clientIntl.getLanguagePathPrefix() || '/');
    }
    static loadLobbyScene(parameter) {
        if (parameter != this.DEFAULT_PARAMETER_VALUE) return;
        uiManager.sceneController.loadScene(Scene.Lobby);
    }
    static loadSpectateScene(parameter) {
        this.loadLobbyScene(parameter);
        uiManager.lobby.tableController.headerController.openSpectateTab();
    }
    static loadMainPageScene(parameter) {
        if (parameter != this.DEFAULT_PARAMETER_VALUE) return;
        uiManager.sceneController.loadScene(Scene.MainPage);
    }
    static loadCampaignMode(parameter) {
        if (parameter != this.DEFAULT_PARAMETER_VALUE) return;
        void SocketLobbySend.continueCampaignMode();
    }
    static async loadMatchmakingQueue(parameter) {
        const requestedMatchType = Number(parameter);
        if (!activeMatchmakingMatchTypes.has(requestedMatchType)) return;
        await uiManager.modeSelector.waitUntilInitialized;
        if (requestedMatchType == MatchmakingMatchTypes.UnrankedShuffle) await ClientShuffleQueueController.waitForShuffleQueueData();
        uiManager.sceneController.loadScene(Scene.MainPage);
        uiManager.modeSelector.selectCardByMatchType(requestedMatchType);
        uiManager.matchmakingController.sendFindGameMessageToServer(requestedMatchType);
    }
    static loadEnterBotGame(parameterValue) {
        if (parameterValue == BotsMatchType.ColonistRush) return startBotGame(BotsMatchType.ColonistRush);
        startBotGame(BotsMatchType.Hard);
    }
    static loadModeSelection(parameter) {
        const requestedMatchType = parameter;
        void uiManager.goToMainPageAndSelectMatchType(requestedMatchType);
    }
    static async loadCreateRoom(parameter) {
        if (parameter != this.DEFAULT_PARAMETER_VALUE) return;
        await uiManager.modeSelector.waitUntilInitialized;
        await ClientUserState.requireUser();
        SocketLobbySend.clickedCreateRoom(RoomType.Standard, false);
    }
    static loadDiscordScene(parameter, scene) {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        if (parameter != this.DEFAULT_PARAMETER_VALUE) return;
        uiManager.sceneController.loadScene(scene);
        history.replaceState(null, '', window.location.pathname);
    }
    static loadShareActivityPopup() {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        showRewardsProgramDialog(ShareActivityLinkAnalytics.ReturnToHomeAfterGameEndReferralProgramPopupTriggered, ShareActivityLinkAnalytics.ReturnToHomeAfterGameEndReferralProgramSuccessfullyShared);
        SDKRequestHandler.sendShareActivityLinkAnalytic(ShareActivityLinkAnalytics.ReturnToHomeAfterGameEndReferralProgramPrePopupTriggered);
        StorageWrapper.setLastShareActivityLinkPopupTime(new Date());
    }
    static loadDiscordGiftScene(parameter) {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return;
        if (parameter == this.DEFAULT_PARAMETER_VALUE) return;
        uiManager.sceneController.loadScene(Scene.DiscordGifting, {
            recipientUsername: parameter
        });
    }
    static handleSuppressPopups(parameter) {
        if (parameter != this.DEFAULT_PARAMETER_VALUE) return;
        UIEntryUrlParameterController.suppressPopupsOnLoad = true;
    }
}
